export enum HealthcareTeamErrorCodes {
	PtInvitationAlreadyAccepted = "PT_INVITATION_ALREADY_ACCEPTED",
	PtNotFoundByEmail = "PT_NOT_FOUND_BY_EMAIL",
	PtInDifferentCountry = "PT_DIFFERENT_COUNTRY",
	PtAlreadyInHealthcareTeam = "PT_ALREADY_IN_HEALTHCARE_TEAM",
	HealthcareTeamInvitationInWrongCountry = "HEALTHCARE_TEAM_INVITATION_IN_WRONG_COUNTRY",
	PtNotInvited = "PT_NOT_INVITED_IN_HEALTHCARE_TEAM",
	PtNotInHealthcareTeam = "PT_NOT_IN_HEALTHCARE_TEAM",
}

export class InvitationPtNotFoundError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class InvitationPtInDifferentCountryError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class InvitationAlreadyAcceptedError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class InvitationPtAlreadyInHctError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class InvitationPtNotInvitedError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class HealthcareTeamInvitationInWrongCountryError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
